export default __webpack_public_path__ + "static/media/file.9de3f0db.mp4";